import { type FC, type HTMLAttributes, type PropsWithChildren } from "react";

import { I18n } from "@jti/ui/components/I18n";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./ConsumablesSectionTitle.module.scss";

type ConsumablesSectionTitleProps = {
  translationKey: string;
  stepCount: number;
} & HTMLAttributes<HTMLDivElement>;

export const ConsumablesSectionTitle: FC<PropsWithChildren<ConsumablesSectionTitleProps>> = ({
  translationKey,
  stepCount,
  children,
  ...restProps
}) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.stepCountContent} {...restProps}>
      <I18n t={translationKey}>
        <strong className={styles.stepCountLabel}>{__("consumablesForm.section.title.stepCount", [stepCount])}</strong>
        {children}
      </I18n>
    </div>
  );
};
